module.exports = __webpack_public_path__ + "static/img/scene08.9c78b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene08.png
// module id = VUom
// module chunks = 1